import { Injectable } from '@angular/core';
import * as Highstock from 'highcharts/highstock';
import moment from "moment-timezone"

export const ChartStyle = {
  PRIMARY_SERIES_COLOR: '#0092A1',
  PRIMARY_SERIES_THICKNESS: 4,
  ROLLING_SERIES_COLORS: [
    '#0092A1',    // PRIMARY_SERIES_COLOR
    '#5738ff',
    '#0278ad',
    '#999647',
    '#62c0dc',
    '#924565',
    '#fed559',
    '#f38725',
    '#55BF3B',
    '#e65177',
    '#ef6a47',
    '#f5a0a7',
    '#8085e9',
    '#8d4654',
    '#7798BF',
    '#aaeeee',
    '#ff0066',
    '#DF5353',
    '#7798BF',
    '#aaeeee'
  ],
  CHART_BACKGROUND: null
};


@Injectable({
  providedIn: 'root'
})
export class ChartService {
  public static timezone: string;

  constructor() { }

  public static mouseOver(): ((e: Event) => void) {
    return function() {
      const selectedChart = this.series.chart;
      const x  = this.x;
      for (const chart of Highstock.charts) {
        const points = [];
        if (chart && chart !== selectedChart) {
          for (const series of chart.series) {
            for (const point of (<any> series).points) {
              if (point.x === x && point.y !== null) {
                points.push(point);
              }
            }
          }
          for (const p of points) {
            p.setState('hover');
          }
          if (points.length !== 0) {
            (<any> chart).tooltip.refresh(points);
          }
        }
      }
    };
  }

  public static mouseOut(): ((e: Event) => void) {
    return function() {
      const selectedChart = this.series.chart;
      const x = this.x;
      const points = [];
      for (const chart of Highstock.charts) {
        if (chart && chart !== selectedChart) {
          for (const series of chart.series) {
            for (const point of (<any> series).points) {
              if (point.x === x) {
                points.push(point);
              }
            }
          }
          for (const p of points) {
            p.setState();
          }
          if ((<any> chart).tooltip) {
            (<any> chart).tooltip.hide();
          }
        }
      }
    };
  }

  static setGlobals(timezone: string) {
    Highstock.setOptions({
      time: {
        timezone: this.timezone,
        timezoneOffset: new Date().getTimezoneOffset(),
      },
    });
    ChartService.timezone = timezone;
  }

}
